module.exports = __webpack_public_path__ + "img/10(1).cd129455.png";